import { render, staticRenderFns } from "./WorkspaceTabs.vue?vue&type=template&id=49624ac0&scoped=true&"
import script from "./WorkspaceTabs.vue?vue&type=script&lang=js&"
export * from "./WorkspaceTabs.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceTabs.vue?vue&type=style&index=0&id=49624ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49624ac0",
  null
  
)

export default component.exports